const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'mediaManagement',
		'image',
		'imageList'
	],

	config: {
		imageTemplate: './baseFormMediaImageImage',
		imageControls: {
			edit: false,
			renew: false,
			delete: false,
			pause: false
		},
		maxImageWidth: 295,
		maxImageHeight: 280,
		elementWidth: 335,
		elementHeight: 302,
	},

	model: {
		lazyloadStepSize: 15
	},

	methods: {
		prepareImageData: function(image, storage){
			utils.media.image.prepare(image, storage, 'web', this.scope)

			const detectionMemory = utils.media.image.detectRendered(image, storage, false, false, false, false, {
				width: 345,
				height: 200
			});

			if(((((detectionMemory || {}).imageList || [])[0] || {}).rendered || {}).url){
				image.preferredThumb 	= detectionMemory.imageList[0].rendered.url;
				image.preferredWidth 	= detectionMemory.imageList[0].rendered.width;
				image.preferredHeight 	= detectionMemory.imageList[0].rendered.height;
			}
		}
	}
};